<template>
  <div class="map">
    <div
      :class="['ui-container', data.bigComponent ? false : 'ui-container--small']"
    >
      <BasePicture class="map__picture" :data="Object.assign(data, { tagImg: false })" />

      <BaseButtonRounded :data="data" />
    </div>
  </div>
</template>

<script>
import BasePicture from '@/components/BasePicture';
import BaseButtonRounded from '@/components/BaseButtonRounded';

export default {
  name: 'mapComp',

  components: {
    BasePicture,
    BaseButtonRounded,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/utils";

.map {
  position: relative;
  width: 100%;

  .ui-container {
    position: relative;
    width: 100%;
    padding: 80px 0;
  }

  &__picture {
    position: relative;
    width: 100%;

    @include aspect-ratio(0.8, 1);

    @include mq(ipadP) {
      @include aspect-ratio(1, 0.6);
    }
  }

  button {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate3d(-50%, -50%, 0);
  }
}
</style>

